var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overflow-x-hidden",attrs:{"id":"create-section"}},[_c('Navbar',{attrs:{"showDownloadButton":true}}),_vm._v(" "),_c('CreateHero'),_vm._v(" "),_c('CreateGenerateAndPrint'),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }